<template>
<div>
  <div><org-change @orgChange="orgChange"/></div>

  <div>
    <div class="container">
      <title-cop  :title="'社区各巡查类型统计'"/>
      <div class="user_status"><type-cop :list="labelList" @change="typeChange" /></div>
    </div>

    <div class="container">
      <title-cop  :title="'社区各网格巡查统计'"  :tip="'点击上方巡查类型进行切换'" />
      <div class="peple_change"><width-bar :labelName="valueName" :dataName="typeName ? typeName + '数统计' : '巡查数统计'" :labelCount="valueList" /></div>
    </div>

  </div>
</div>
</template>

<script>
import orgChange from './components/orgChange.vue'
import SexProgress from './components/sex-progress.vue'
import titleCop from './components/title-cop'
import totalNumber from './components/total-Number'
import UserType from './components/userType.vue'
import widthBar from './components/widthBar.vue'
import lineCop from './components/line-cop.vue'
import stackBar from './components/stackBar.vue'
import typeCop from './components/type-cop.vue'
export default {
  components: {
    titleCop,
    totalNumber,
    SexProgress,
    orgChange,
    widthBar,
    UserType,
    lineCop,
    stackBar,
    typeCop
  },
  data () {
    return {
      grid: 0,
      isStreet: true,
      orgList: [],
      dictId: 0,
      labelList: [],
      valueName: [],
      valueList: [],
      typeName: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    orgChange (id, isStreet) {
      this.grid = id
      this.isStreet = isStreet
      this.init()
    },
    typeChange (index, id, name) {
      if (id) {
        this.dictId = id
        this.typeName = name
        this.getTypeList()
      } else {
        this.type = null
        this.dictId = null
        this.getTypeList()
      }
    },
    init () {
      this.getTypeList()
    },
    getTypeList () {
      this.$http({
        url: this.$http.adornUrl('/wxapp/statistics/inspectionCountStreet'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.$globalData.userInfo.orgId,
          gridId: this.grid ? this.grid + '' : null ,
          dictId: this.dictId || null
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.labelList = [{name: '巡查总数', value: 0, unit: '个', img: require('@/assets/img/statistics/patrol_count.png'), list: []}]
          this.labelList[0].list = data.data.inspectionTypeCount.map(item => {
            this.labelList[0].value += item.labelCount
            return {
              name: item.labelName,
              value: item.labelCount,
              id: item.labelId,
              unit: '个'
            }
          })
          this.valueName = data.data.communityGridCount.map(item => item.communityGridName)
          this.valueList = data.data.communityGridCount.map(item => item.inspectionCount)
        } else {
          this.$toast.fail(data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.topOrgBox {
  padding: 20px 30px;
  .topOrg {
    width: 100%;
    height: 74px;
    text-align: center;
    line-height: 74px;
    margin: 0;
    border-radius: 10px;
    background-color: #fff;
    .pull-icon {
        width: 10px;
    }
  }
}
.container {
  background-color: #fff;
  margin-bottom: 20px;
}
.split_line {
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 2px solid #eee;
}
.user_status {
  height: 400px;
}
.user_age {
  height: 500px;
}
.peple_change {
  height: 500px;
}
</style>
